import React from 'react';
import { StatCard } from '../UI';
import { fmt } from '../../utils';
import { fmtCount } from './erUtils';

export default function ExpenseRegisterStats({ stats }) {
  const tiles = [
    { key: 'total_transactions', label: 'Total Transactions', color: 'blue', icon: '📄', value: fmtCount(stats?.total_transactions) },
    { key: 'total_amount', label: 'Total Amount', color: 'green', icon: '₦', value: fmt(stats?.total_amount) },
    { key: 'departments', label: 'Departments', color: 'purple', icon: '🏢', value: fmtCount(stats?.departments) },
    { key: 'vendors', label: 'Vendors', color: 'amber', icon: '🚚', value: fmtCount(stats?.vendors) },
    { key: 'projects', label: 'Projects', color: 'cyan', icon: '◈', value: fmtCount(stats?.projects) },
    { key: 'vouchers', label: 'Vouchers', color: 'accent', icon: '💳', value: fmtCount(stats?.vouchers) },
  ];

  return (
    // repeat(6, 1fr) forced six tracks whatever the width, and grid items
    // default to min-width:auto — so a long label like "TOTAL TRANSACTIONS"
    // or a wide figure could not shrink, widening the row past the page and
    // dragging every card below it (including the filter card) out with it.
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
      gap: 14, width: '100%',
    }}>
      {tiles.map(t => (
        <StatCard
          key={t.key}
          label={t.label}
          value={t.value}
          color={t.color}
          icon={t.icon}
          style={{ border: '2px solid black', borderRadius: 14, boxShadow: '0 2px 10px -1px rgba(15,23,42,0.03)', minHeight: 118, padding: '16px 18px', minWidth: 0 }}
        />
      ))}
    </div>
  );
}
